import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Code, Wrench, Database, Cloud } from 'lucide-react';
import { profileData } from '../data/mock';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Languages',
      icon: Code,
      skills: profileData.skills.languages,
      color: 'from-[#00AFF0] to-[#0099D6]'
    },
    {
      title: 'Frameworks',
      icon: Wrench,
      skills: profileData.skills.frameworks,
      color: 'from-[#0099D6] to-[#0088C2]'
    },
    {
      title: 'Databases',
      icon: Database,
      skills: profileData.skills.databases,
      color: 'from-[#0088C2] to-[#0077AD]'
    },
    {
      title: 'Tools & Cloud',
      icon: Cloud,
      skills: [...profileData.skills.tools, ...profileData.skills.other],
      color: 'from-[#0077AD] to-[#006699]'
    }
  ];

  return (
    <section id="skills" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Technical <span className="text-[#00AFF0]">Skills</span>
          </h2>
          <div className="w-20 h-1 bg-[#00AFF0] mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            A comprehensive toolkit for building modern, scalable applications
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {skillCategories.map((category, index) => (
            <Card
              key={index}
              className="p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-2 hover:border-[#00AFF0]/50"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${category.color} flex items-center justify-center`}>
                  <category.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{category.title}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill, idx) => (
                  <Badge
                    key={idx}
                    className="px-4 py-2 text-sm bg-white border-2 border-gray-200 text-gray-700 hover:border-[#00AFF0] hover:text-[#00AFF0] transition-all duration-300 cursor-default"
                  >
                    {skill}
                  </Badge>
                ))}
              </div>
            </Card>
          ))}
        </div>

        {/* Additional Skills Highlight */}
        <div className="mt-12 text-center">
          <Card className="p-8 bg-gradient-to-r from-[#00AFF0]/5 to-[#0099D6]/5 border-2 border-[#00AFF0]/20">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Core Competencies</h3>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                'Microservices Architecture',
                'System Design',
                'Cloud Computing',
                'Agile/Scrum',
                'CI/CD',
                'Test-Driven Development',
                'API Design',
                'Performance Optimization',
                'Code Review',
                'Mentoring'
              ].map((competency, idx) => (
                <Badge
                  key={idx}
                  className="px-4 py-2 bg-white text-[#00AFF0] border-2 border-[#00AFF0] hover:bg-[#00AFF0] hover:text-white transition-all duration-300 cursor-default"
                >
                  {competency}
                </Badge>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Skills;